import { Middleware, RequestContext } from '../../../generated/api';
import { getDeviceID } from '../../user/sessionTracker';

export default class DeviceInfoMiddleware implements Middleware {
  async pre(request: RequestContext) {
    const deviceId = await getDeviceID();
    return {
      ...request,
      init: {
        ...request.init,
        headers: {
          ...request.init.headers,
          'X-Device-ID': deviceId,
        },
      },
    };
  }
}
